import { Button } from "../../components/core/basic/Button";
import { TextField } from "../../components/fields/base/TextField";
import { Flex } from "../../../styled-system/jsx";
import { Controller, useForm, type FieldErrors } from "react-hook-form";
import { css, cx } from "../../../styled-system/css";
import { formField } from "../../../styled-system/recipes";
import { useTranslation } from "react-i18next";

interface OTPFormData {
  otp: string;
}

const INITIAL_DATA: OTPFormData = {
  otp: "",
};

interface MFACheckProps {
  onSuccess: (otp: string) => void;
  showRecoveryForm: () => void;
  isPending: boolean;
  parentErrors: FieldErrors;
}

const MFAForm = ({ onSuccess, showRecoveryForm, parentErrors, isPending }: MFACheckProps) => {
  const { t } = useTranslation(["auth", "validation"]);
  const classes = formField();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: INITIAL_DATA,
  });

  const combinedErrors = { ...errors, ...parentErrors };

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => {
          onSuccess(data.otp);
        })}
      >
        <Flex gap={"medium"} direction={"column"}>
          <Controller
            name={"otp"}
            control={control}
            rules={{
              required: {
                value: true,
                message: t(($) => $.validation.otp["Please enter the OTP from your authenticator app"]),
              },
              pattern: {
                value: /(?<!.)(\d{3})(\s?)(\d{3})(?!.)|(?<!.)(\d{4})(\s?)(\d{4})(?!.)/g,
                message: t(($) => $.validation.otp["Invalid OTP format"]),
              },
            }}
            render={({ field, fieldState }) => (
              <TextField
                label={t(($) => $.auth.mfa.OTP)}
                type={"text"}
                autoComplete="one-time-code"
                inputMode="numeric"
                onChange={(value) => {
                  field.onChange(value);
                }}
                onBlur={field.onBlur}
                errorMessage={fieldState.error?.message}
              />
            )}
          />
          {typeof combinedErrors.root?.message === "string" && (
            <p className={cx(classes.error)}>{combinedErrors.root.message}</p>
          )}
        </Flex>
        <Button isPending={isPending} className={css({ width: "100%", marginTop: "large" })} type="submit">
          {t(($) => $.auth.mfa["Log In"])}
        </Button>
      </form>
      <hr className={css({ width: "100%", marginY: "medium" })} />
      <div className={css({ width: "100%", marginTop: "medium", textAlign: "center" })}>
        {t(($) => $.auth.mfa["Lost OTP Access?"])}
        <Flex justifyContent={"center"} marginTop={"small"} paddingX={"medium"}>
          <Button
            variant={"link"}
            onClick={() => {
              showRecoveryForm();
            }}
          >
            {t(($) => $.auth.mfa["Recover Here"])}
          </Button>
        </Flex>
      </div>
    </>
  );
};

export default MFAForm;
